module.exports = __webpack_public_path__ + "img/close.6d7d2ba1.svg";